module.exports = "/_next/static/images/lines-08965ca1657ad0bb9fc2428ce4d6a0b6.png.webp";